import styled from 'styled-components'

import { TypeStyle, fromMd } from '@syconium/little-miss-figgy'

export const Container = styled.div`
  flex: 1;
  min-width: 256px;
  padding: ${o => o.theme.spacing(0, 4, 6, 4)};

  ${fromMd} {
    margin: 0 auto;
    max-width: 350px;
    padding: ${o => o.theme.spacing(0, 0, 6)};
  }
`

export const Title = styled(TypeStyle.HeadlineSmall)``

export const Price = styled(TypeStyle.HeadlineExtraSmall)``

export const Description = styled(TypeStyle.BodyDefault)`
  margin-top: 10px;
`

export const BadgesSectionContainer = styled.div`
  padding-top: 10px;
`

export const SiteWidePromoWrap = styled(TypeStyle.BodyNano)`
  color: ${o => o.theme.color.deprecated.red.error};
  font-weight: 600;
  padding: 24px 0 0 0;
  text-transform: uppercase;
`
